<template>
  <div>
    <!-- 轮播图 -->
    <div class="home-banner">
      <img :src="index_bg"/>
      <!-- <div class="container">
        <div class="adv">
          <div class="supplier">企业级别HTTO服务提供商</div>
          <div class="support">为大数据产业发展提供有力的支持，行业领先，您值得信赖的代理首选</div>
          <div class="mt100 txt">
            <div class="tryout">14款产品全部免费试用</div>
            <div class="draw">注册成功 认证即领取</div>
          </div>
        </div>
        <ul class="u-flex u-row-between card">
          <li class="u-flex">
            <img src="../assets/images/sy_lunbotu_icon_selected_1.png" />
            <div class="ml10">
              <div>资源纯净全自助服务器</div>
              <div>均为高匿，稳定度95%以上</div>
            </div>
          </li>
          <li class="u-flex">
            <img src="../assets/images/sy_lunbotu_icon_2.png" />
            <div class="ml10">
              <div>海量资源</div>
              <div>每日100CW高匿代理IP池</div>
            </div>
          </li>
          <li class="u-flex">
            <img src="../assets/images/sy_lunbotu_icon_3.png" />
            <div class="ml10">
              <div>多种API资源</div>
              <div>超低延迟，快速接入</div>
            </div>
          </li>
          <li class="u-flex">
            <img src="../assets/images/sy_lunbotu_icon_4.png" />
            <div class="ml10">
              <div>HTTPS/SOCK5代理</div>
              <div>爬虫动态转发，覆盖全部需求</div>
            </div>
          </li>
        </ul>
      </div> -->
    </div>
    <div class="main">
      <!-- 提供 -->
      <div class="u-flex provide">
        <div class="container">
          <div class="title">
            <div class="zh-title">我们为您提供</div>
            <div class="en-title">WE PROVIDE FOR YOU</div>
          </div>
          <div class="mt100 u-flex u-col-top u-row-between">

            <ul class="tab">
              <li class="u-flex" :class="{ 'active': activeIndex === index }" v-for="(item, index) in goods"
                  :key="index" @click="onTab('provide', index)">{{ item.title }}
              </li>
            </ul>
            <div class="tab-content" v-if="goods.length > 0 && goods[activeIndex]">
              <img style="width: 100%;height: 200px;" :src="goods[activeIndex].image" alt="高效代理">
              <h3>产品特点</h3>
              <p v-html="goods[activeIndex].characteristic || '暂无描述' ">

              </p>
              <div class="mt70">
                <el-button type="primary" round @click="goBuy(goods[activeIndex])">查看详情</el-button>
                <!-- <el-button class="ml36" round @click="goDetail(goods[activeIndex])"></el-button> -->
              </div>
            </div>
            <div class="tab-content" v-else>
              <div style="text-align: center; padding: 40px; color: #999;">
                加载中...
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- 服务要求 -->
      <div class="requirement">
        <div class="container">
          <div class="title">
            <div class="zh-title">满足您任何大数据服务要求</div>
            <div class="en-title">MEET ANY OF YOUR BIG DATA SERVICE REQUIREMENTS</div>
          </div>

          <ul class="u-flex  meet-list">
            <li v-for="(item, index) in carousel">
              <img :src="item.img_text" :alt="item.title">
              <div class="box">
                <div class="name">{{ item.title }}</div>
                <p>{{ item.description }} </p>
              </div>
            </li>

          </ul>
        </div>
      </div>
      <!-- 卓泓咨询 -->
      <div class="u-flex consulting">
        <div class="container">
          <div class="title">
            <div class="zh-title">卓泓咨询</div>
            <div class="en-title">QILIN CONSULTING</div>
          </div>
          <div class="mt100">
            <ul class="u-flex u-row-center tab" style=" cursor:pointer;">
              <li :class="{ 'active': curIndex === index }" v-for="(item, index) in consultingList" :key="index"
                  @click="onTab('consulting', index)">{{ item.name }}
              </li>
            </ul>
            <div class="tab-content" style=" cursor:pointer;"
                 v-if="consultingList.length > 0 && consultingList[curIndex] && consultingList[curIndex].document">
              <ul class="u-flex u-flex-wrap faq-list">
                <li v-for="(item, index) in consultingList[curIndex].document" :key="index"
                    :class="{ 'active': selectedDocIndex === index }" @click="onTabDetail(index, item.id)">
                  <div class="name">{{ item.title }}</div>
                  <div style="display: -webkit-box;-webkit-box-orient: vertical;
                  padding:10px 0;font-size: 13px;color: #666;
                  overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;">
                    {{ item.summary }}
                  </div>


                </li>
              </ul>
              <div class="mt24 u-flex u-row-center">
                <el-button round @click="goToFaqDetail">点击查看</el-button>
              </div>
            </div>
            <div class="tab-content" v-else>
              <div style="text-align: center; padding: 40px; color: #999;">
                暂无数据
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- 福利 -->
      <div class="welfare">
        <div class="container">
          <ul class="u-flex">

            <li class="u-flex u-row-center">
              <div>
                <div class="name">充值福利</div>
                <div class="slogan">多充多送，您的性价比首选</div>
              </div>
            </li>
            <li class="u-flex u-row-right">
              <div>
                <div class="name">客服QQ:{{ customer_service_qq }}</div>
                <div class="slogan">为您解决各类 问题</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Index',
  data() {

    return {
      carousel: [],
      customer_service_qq: '',
      index_bg: '',
      activeIndex: 0,
      provideList: [],
      curIndex: 0,
      consultingList: [],
      goods: [],
      documentId: 0,
      selectedDocIndex: -1, // 选中的文档索引
    }
  },
  created() {
    this.$api.home.index().then(res => {
      let data = res.data || {}
      this.goods = data.goods || []
      this.consultingList = data.document || []
      this.index_bg = data.index_bg || ''
      this.carousel = data.carousel || []
      this.customer_service_qq = data.footer.customer_service_qq || ''
      console.log(data);

      // 默认选中第一个文档
      this.$nextTick(() => {
        this.selectedDocIndex = -1
      })
    })
  },
  mounted() {
  },
  methods: {
    onTabDetail(index, id) {
      // 如果点击的是当前已选中的项目，则取消选中
      if (this.selectedDocIndex === index) {
        this.selectedDocIndex = -1
      } else {
        // 否则选中新点击的项目
        this.selectedDocIndex = index
      }

    },
    onTab(type, index) {
      if (type === 'provide') {
        this.activeIndex = index
      } else {
        // 确保索引在有效范围内
        if (index >= 0 && index < this.consultingList.length) {
          this.curIndex = index
          // 切换咨询分类时，默认选中第一个文档
          this.$nextTick(() => {
            this.selectedDocIndex = -1
          })
        }
      }
    },
    goBuy(item) {
      if (!item) {
        this.$message.warning('商品信息不存在')
        return
      }
      this.$router.push({
        path: '/Introduce',
        query: {
          id: item.id
        }
      })
    },
    goDetail(item) {
      this.$router.push({
        path: '/detail',
        query: {
          id: item.id
        }
      })
    },
    goToFaqDetail() {

      // 检查是否有选中的文档
      if (this.selectedDocIndex === -1) {

        if (this.consultingList.length > 0) {
          this.selectedDocIndex = 1;
        }else {
          this.$message.warning('文档不存在')
          return
        }
      }

      // 获取当前选中的文档
      const currentDocument = this.consultingList[this.curIndex].document[this.selectedDocIndex]

      // 跳转到FaqDetail页面，传递分类ID和文档ID
      this.$router.push({
        path: '/faqDetail',
        query: {
          cid: this.consultingList[this.curIndex].id,
          id: currentDocument.id
        }
      })
    }
  },

}
</script>

<style scoped>
/* banner */
.home-banner {
  position: relative;
  min-height: 320px;
  margin-top: 80px;
}

.home-banner img {
  width: 100%;
  display: block;
}

.adv {
  position: absolute;
  top: 100px;
}

.supplier {
  color: #000;
  font-size: 50px;
  font-weight: 700;
}

.support {
  margin-top: 40px;
  color: #999;
  font-size: 18px;
}

.txt {
  padding: 15px;
  width: 260px;
  color: #fff;
  font-size: 14px;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  background-image: linear-gradient(to right, #ed722f, #f1a85b);
}

.tryout {
  font-size: 16px;
}

.draw {
  margin-top: 6px;
  font-size: 12px;
}

.card {
  position: absolute;
  bottom: 10px;
  width: 1200px;
}

.card li {
  padding: 30px 20px;
  width: calc(25% - 8px);
  color: #2682ff;
  font-size: 14px;
  border-radius: 8px;
  box-sizing: border-box;
  background: #fff;
}

.card li:first-child {
  color: #fff;
  background: #2682ff;
}

.card li img {
  width: 51px;
  height: 51px;
}

.zh-title {
  color: #000;
  font-size: 30px;
}

.en-title {
  color: #333;
  font-size: 20px;
}

/* 提供 */
.provide {
  padding: 60px 0;
  background: #fbf9fa;
}

.provide .tab {
  width: 180px;
}

.provide .tab li {
  margin-bottom: 40px;
  color: #666;
  font-size: 16px;
  cursor: pointer;
}

.provide .tab li::before {
  margin-right: 10px;
  content: '';
  display: inline-block;
  width: 10px;
  height: 16px;
  background: #fbf9fa;

}

.provide .tab .active {
  color: #2682ff;;
}

.provide .tab .active::before {
  background: linear-gradient(to right, #2682ff, #b9d7fb, #fff);
}

.provide .tab-content {
  padding-left: 10px;
  width: calc(100% - 180px);
}

.provide .tab-content img {
  width: 100%;
}

.provide .tab-content h3 {
  padding: 20px 0 15px;
  color: #333;
  font-size: 18px;
}

.provide .tab-content p {
  line-height: 36px;
  color: #999;
  font-size: 14px;
}

.requirement {
  padding: 60px 0;
  background: #e5eaf0;
}

.meet-list {
  margin-top: 90px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
}

.meet-list li {
  border-radius: 5px;
  background: #fff;
}

.meet-list li img {
  width: 100%;
  height: 335px;
  display: block;
}

.meet-list li .box {
  padding: 24px 20px;
  min-height: 150px;
  box-sizing: border-box;
}

.meet-list li .nanme {
  color: #333;
  font-size: 16px;
}

.meet-list li p {
  margin-top: 10px;
  line-height: 24px;
  color: #999;
  font-size: 14px;
}

.consulting {
  padding: 60px 0;
  background: #fbf9fa;
}

.consulting .tab {
  padding: 0 100px;
  width: 1200px;
  box-sizing: border-box;
}

.consulting .tab li {
  width: calc(25% - 10px);
  color: #333;
  font-size: 16px;
  text-align: center;
}

.consulting .tab li.active {
  color: #2682ff;
}

.consulting .tab-content {
  margin-top: 40px;
}

.faq-list li {
  margin-bottom: 12px;
  margin-right: 12px;
  padding: 16px;
  width: calc(50% - 6px);
  border-radius: 8px;
  box-sizing: border-box;
  background: #fff;

}


.faq-list li:nth-of-type(2n) {
  margin-right: 0;
}

.faq-list li .name {
  font-size: 16px;
}

.faq-list li p {
  margin-top: 10px;
  line-height: 24px;
  font-size: 14px;
}


.faq-list li.active {
  transform: scale(1.02);
  transition: all 0.2s ease;
  box-shadow: 8px 8px 25px 0px rgba(199, 196, 196, 0.8),

}

.welfare {
  padding: 32px 0;
  background: url(../assets/images/gmdl_bg.png) no-repeat 100% center;
}

.welfare ul li {
  width: 33.3333%;
}

.welfare li .name {
  color: #000;
  font-size: 20px;
}

.welfare li .slogan {
  padding: 4px 0 20px;
  color: #000;
  font-size: 14px;
}
</style>
